import React from 'react';
import { RichText, Image } from '@sitecore-jss/sitecore-jss-react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import DictionaryText from './DictionaryText';

const EngagementsBlockCard = (props) => {
  const { title, desc, link, image , sitecoreContext } = props;
  const Wrapper = link ? 'a' : 'div'; // choose element

  return (
    <Wrapper {...(link ? { href: link } : {})}>
      <div className="w-full block h-fit group">
        <div className="lg:h-[382px] h-[316px] overflow-clip">
          <img src={image} className="mb-8 w-full h-full group-hover:scale-105 transition-all duration-500 object-cover object-center" />
        </div>

        {sitecoreContext.pageEditing ? (
          <RichText field={title} className="mt-6 leading-[28px] text-black-300 font-semibold text-base" />
        ) : (
          <h3 className="mt-6 leading-[28px] text-black-300 font-semibold text-base">{title?.value}</h3>
        )}
        { desc && <RichText field={desc} className="mt-6 text-base leading-[28px] font-medium text-black-300" />}

      </div>
    </Wrapper>
  );
};

export default withSitecoreContext()(EngagementsBlockCard);
